module.exports = __webpack_public_path__ + "img/remis-fleet.84655935.png";